import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { mixed, object } from "yup";
import { ProductionBlockchains } from "../../../../chain/models/internal";
import { address } from "../../../../common/models/fields";
import { Field } from "../../internal/field";

export const useAllowedChains = (item: Field.DefaultField) => {
  const { i18n } = useTranslation();
  const currentLanguage = useMemo(() => i18n.language.replaceAll("-", "_"), [
    i18n,
  ]);

  return useMemo(
    () =>
      Field.isSourceWalletField(item) ||
      Field.isDestinationWalletField(item) ||
      Field.isStakingWalletField(item)
        ? item.typeDetails.availableOptions?.[currentLanguage] || []
        : ProductionBlockchains.keys,
    [item, currentLanguage]
  );
};

export const useSchema = () => {
  const addressSchema = address.useSchema();
  const { t, i18n } = useTranslation("fields");
  const currentLanguage = useMemo(() => i18n.language.replaceAll("-", "_"), [
    i18n,
  ]);
  return useCallback(
    (f: Field.DefaultField) =>
      object().shape({
        address: addressSchema,
        chain: mixed()
          .label(t("chain"))
          .oneOf(
            Field.isSourceWalletField(f) ||
              Field.isDestinationWalletField(f) ||
              Field.isStakingWalletField(f)
              ? f.typeDetails.availableOptions?.[currentLanguage] || []
              : ProductionBlockchains.keys
          )
          .required(
            t("required-field", {
              ns: "errors",
              field: t("wallet-chain"),
            })
          ),
      }),
    [address, currentLanguage]
  );
};
